// Fetch autenticado — injeta o JWT do backend (localStorage) em todas as chamadas.
// Num 401 (token vencido), renova em silêncio pela ponte de lib/sessao.js —
// o AuthProvider registra lá a renovação (MSAL silencioso → /api/auth/microsoft-login),
// deduplicada entre chamadas concorrentes — e repete a chamada UMA vez. Se a
// renovação falhar, o aviso "Sua sessão expirou" cobre a tela (que continua
// montada) e esta função devolve o 401 original: o chamador segue lendo
// `res.ok`/`res.status` como sempre. Mesma assinatura/retorno de antes.
import { comSessaoRenovada } from './sessao';

const lerToken = () => {
  try { return localStorage.getItem('auth_token'); } catch { return null; }
};

const authedFetch = (url, options = {}) => comSessaoRenovada(
  (token) => {
    const headers = { ...options.headers };
    if (token) headers.Authorization = `Bearer ${token}`;
    return fetch(url, { ...options, headers });
  },
  lerToken,
);

export default authedFetch;
